import _ from 'lodash'
import type {Experiment, DSConfig} from '@wix/document-services-types'

interface FeatureConfig {
    extensionsList?: string[]
    modulesList?: string[]
    configOptions?: Partial<Omit<DSConfig, 'extensionsList' | 'modulesList'>>
}

interface OptionalFeatures extends Record<string, FeatureConfig> {}

const featureConfigs: OptionalFeatures = {
    miniSite: {
        extensionsList: ['miniSite'],
        modulesList: ['miniSitePublicAPI']
    },
    presetsPreviewOnly: {
        configOptions: {
            disableFragments: true
        }
    }
}

const extendWithOptionalFeatures = (config: DSConfig, optionalFeatures: OptionalFeatures, features?: string[]) => {
    if (!features) {
        return config
    }
    const featuresToEnable = {config, ..._.pick(optionalFeatures, features)}
    const modulesList = _(featuresToEnable).flatMap('modulesList').uniq().compact().value()
    const extensionsList = _(featuresToEnable).flatMap('extensionsList').uniq().compact().value()
    const configOptions = _(featuresToEnable)
        .map('configOptions')
        .reduce((acc, options) => ({...acc, ...options}), {})
    return {
        ...config,
        modulesList,
        extensionsList,
        ...configOptions
    }
}

const extendWithFeatures = (config: DSConfig, features?: string[]) =>
    extendWithOptionalFeatures(config, featureConfigs, features)

const extendWithExperimentalFeatures = (config: DSConfig, experimentInstance: Experiment) => {
    if (!config.experimentalConfigOptions) {
        return config
    }
    const optionalFeatures = config.experimentalConfigOptions
    const runningExperiments = _(config.experimentalConfigOptions)
        .keys()
        .filter(experimentName => experimentInstance.isOpen(experimentName))
        .value()

    return extendWithOptionalFeatures(
        _.omit(config, ['experimentalConfigOptions']),
        optionalFeatures,
        runningExperiments
    )
}
export {extendWithFeatures, extendWithExperimentalFeatures}
